export const ArovySubdomainValidationPattern = /^[a-z0-9_-]{1,64}$/ui;
